import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M4 16h24" fill="none" />
  </Icon>
);
